<template lang="pug">
#view_myproduct
  v-layout
    v-flex.myproduct
      h2.omnesMedium.mp-title Mi Producto
      v-layout.row-mp-data.hr
        v-flex.mp-data-name(lg4)
          span Producto
        v-flex.mp-data-value(lg8)
          p {{ product }}
      v-layout.row-mp-data.hr
        v-flex.mp-data-name(lg4)
          span Póliza
        v-flex.mp-data-value(lg8)
          p {{ policy }}
      v-layout.row-mp-data
        v-flex.mp-data-name(lg4)
          span Tipo de solicitud
        v-flex.mp-data-value(lg8)
          p {{ requestType }}
</template>

<script>
/**
 * @component PanelSOATProduct
 * @description Panel informativo que muestra los datos del producto SOAT y tipo de solicitud.
 * Se utiliza en el flujo de trámites para mostrar contexto al usuario.
 * 
 * @example
 * <PanelSOATProduct
 *   product="SOAT"
 *   policy="123456789"
 *   request-type="Anulación de póliza"
 * />
 */
export default {
  name: 'PanelSOATProduct',
  props: {
    product: {
      type: String,
      required: true
    },
    policy: {
      type: String,
      required: true
    },
    requestType: {
      type: String,
      default: 'Anulación de póliza'
    }
  }
}
</script>

<style scoped>
#view_myproduct.lg6 {
  margin: 1em 2em;
}

#view_myproduct .myproduct {
  border: solid 1px #E7EAED;
  border-radius: 3px;
  background-color: #FAFBFC;
  padding: 30px;
  margin: 1em 0;
}

.mp-title {
  font-size: 18px;
  color: #000;
  font-weight: 500;
  margin-bottom: 20px;
}

.row-mp-data {
  padding: 12px 0;
}

.row-mp-data.hr {
  border-bottom: 1px solid #E7EAED;
}

.mp-data-name {
  font-size: 14px;
  color: #6C757D;
}

.mp-data-value {
  font-size: 14px;
  color: #000;
  font-weight: 500;
}

.mp-data-value p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/soat/PanelSOATProduct.vue